import { Component, ElementRef, HostBinding, computed, inject, input } from '@angular/core';
import { cva } from 'class-variance-authority';
import type { ClassValue } from 'clsx';

import { knx } from '../../../utils/src';

export type EmptySize = 'sm' | 'md' | 'lg';

const emptyVariants = cva('flex items-center justify-center px-4 font-semibold text-gray-300', {
  variants: {
    size: {
      sm: 'py-8',
      md: 'py-16',
      lg: 'py-24',
    },
  },
  defaultVariants: {
    size: 'md',
  },
});

@Component({
  selector: 'knx-empty',
  template: '<ng-content></ng-content>',
  host: { '[class]': '_computedClass()' },
})
export class KnxEmpty {
  private readonly elementRef = inject(ElementRef);

  @HostBinding('attr.data-testid') testid = this.getHostAttribute('data-testid') ?? 'knx-empty';

  size = input<EmptySize>('md', { alias: 'knxSize' });

  readonly userClass = input<ClassValue>('', { alias: 'class' });

  protected readonly _computedClass = computed(() =>
    knx(emptyVariants({ size: this.size() }), this.userClass()),
  );

  private getHostElement(): HTMLElement {
    return this.elementRef.nativeElement;
  }

  private getHostAttribute(attributes: string): string | null {
    return this.getHostElement().getAttribute(attributes);
  }
}
